import { render, staticRenderFns } from "./FlowObjectStateBadge.vue?vue&type=template&id=234677ed&functional=true"
import script from "./FlowObjectStateBadge.vue?vue&type=script&lang=js"
export * from "./FlowObjectStateBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports